import 'print-this';

export default defineNuxtPlugin(() => {
    return {
        provide: {
            printThis: (selector, options = {}) => {
                $(selector).printThis(options);
            },
        },
    };
});
